import { Component } from "@angular/core";
import { PolicyHeaderComponent } from "../../policy-documents/policy-header/policy-header.component";

@Component({
    selector: "app-aul-106-24",
    standalone: true,
    imports: [PolicyHeaderComponent],
    templateUrl: './aul-106-24.component.html',
    styleUrl: './aul-106-24.component.scss'
})
export class Aul10624Component{

}